import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyStateComponent } from './empty-state.component';
import {EvaButtonModule} from "../eva-button/eva-button.module";
import {TagTextModule} from "../tag-text/tag-text.module";
import { PaymentPromosModule } from "../payment-promos/payment-promos.module";

@NgModule({
  declarations: [EmptyStateComponent],
  exports: [
    EmptyStateComponent
  ],
  imports: [
    CommonModule,
    EvaButtonModule,
    TagTextModule,
    PaymentPromosModule,
]
})
export class EmptyStateModule { }
